import { z } from 'zod';

/**
 * Interventions sous-traitées à un partenaire. BCL (Amine) assigne une
 * intervention sur un dossier à un partenaire ; le partenaire dépose son
 * rapport ; le super-admin valide / rejette / met en litige. Une intervention
 * validée est « confirmée pour paiement » (cf. facturation sous-traitant).
 */

export const partnerInterventionStatusSchema = z.enum([
  'assignee',
  'rapport_depose',
  'validee',
  'rejetee',
  'litige',
]);
export type PartnerInterventionStatus = z.infer<
  typeof partnerInterventionStatusSchema
>;

export const assignInterventionSchema = z.object({
  projectId: z.string().uuid(),
  partnerId: z.string().uuid(),
  scheduledAt: z.string().datetime().optional(),
  notes: z.string().trim().max(2000).optional(),
});
export type AssignInterventionInput = z.infer<typeof assignInterventionSchema>;

export const submitInterventionReportSchema = z.object({
  reportContent: z.string().trim().min(1).max(20000),
});
export type SubmitInterventionReportInput = z.infer<
  typeof submitInterventionReportSchema
>;

export const reviewInterventionSchema = z
  .object({
    decision: z.enum(['validee', 'rejetee', 'litige']),
    reason: z.string().trim().max(500).optional(),
  })
  .refine((d) => d.decision === 'validee' || !!d.reason, {
    message: 'Motif requis pour un rejet ou une mise en litige',
    path: ['reason'],
  });
export type ReviewInterventionInput = z.infer<typeof reviewInterventionSchema>;

export const partnerInterventionSchema = z.object({
  id: z.string().uuid(),
  projectId: z.string().uuid(),
  partnerId: z.string().uuid(),
  status: partnerInterventionStatusSchema,
  scheduledAt: z.string().datetime().nullable(),
  notes: z.string().nullable(),
  reportContent: z.string().nullable(),
  reportSubmittedAt: z.string().datetime().nullable(),
  reviewReason: z.string().nullable(),
  reviewedAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type PartnerIntervention = z.infer<typeof partnerInterventionSchema>;
